<template>
  <div :data-test="'determination-question-row-' + questionKey">
    <div class="row">
      <div class="col-sm-8">
        <span
          class="f-500"
          data-test="determination-question"
        >
          {{ question.title ? question.title : question.text }}
        </span>
        &nbsp;
        <span
          v-if="question.help"
          v-tooltip="question.help ? question.help : 'No help for this item'"
          class="c-indigo-500"
        >
          <i class="zmdi zmdi-help" />
        </span>
        <br />
        <span v-if="question.title && question.text" class="small c-gray">
          {{ question.text }}
        </span>
        <slot name="notice" />
      </div>
      <div class="col-sm-3">
        <div class="row">
          <div class="col-sm-3">
            <a
              :class="{
                'bgm-green-400 green c-white ': answerIs('yes'),
                'bgm-truegray-400 c-gray': !answerIs('yes'),
              }"
              href="#"
              class="label label-default f-12"
              data-toggle="tooltip"
              data-test="determination-answer-yes"
              @click="toggleAnswer('yes')"
            >
              Yes
            </a>
          </div>
          <div class="col-sm-3">
            <a
              :class="{
                'bgm-green-400 green c-white ': answerIs('no'),
                'bgm-truegray-400 c-gray': !answerIs('no'),
              }"
              href="#"
              class="label label-default f-12"
              data-test="determination-answer-no"
              data-toggle="tooltip"
              @click="toggleAnswer('no')"
            >
              No
            </a>
          </div>
          <div class="col-sm-6">
            <a
              v-tooltip="!answerIs('unknown') ? 'Click, if you do not know the answer.' : ''"
              :class="{
                'bgm-orange c-white ': answerIs('unknown'),
                'bgm-truegray-400 c-gray faded': !answerIs('unknown'),
              }"
              href="#"
              class="label label-default f-11"
              data-test="determination-answer-unknown"
              data-toggle="tooltip"
              @click="toggleAnswer('unknown')"
            >
              Don't know
            </a>
          </div>
          <input
            v-model="answerValue"
            :name="questionKeyPrefix + '[' + questionKey + ']'"
            data-toggle="tooltip"
            type="hidden"
          />
        </div>
      </div>
    </div>
    <hr class="m-t-15 m-b-15" />
  </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  name: 'DeterminationSetting',
  props: {
    answer: { type: [String, Boolean], default: null },
    questionKey: { type: String, required: true },
    question: { type: Object, required: true },
    questionKeyPrefix: {
      type: String,
      required: false,
      default: 'determination_questions',
    },
    readOnly: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const answerValue = ref(props.answer)

    watch(
      () => props.answer,
      (newAnswer) => {
        if (!newAnswer) return

        answerValue.value = newAnswer
      },
    )

    return {
      answerValue,
      answerIs: (answer) => answerValue.value === answer,
      toggleAnswer: (answer) => {
        if (props.readOnly) return

        answerValue.value = answer
        emit('changed', {
          questionKey: props.questionKey,
          answer: answerValue.value,
        })
      },
    }
  },
}
</script>
